var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.4","d":"M9.5 10.5L12.1997 13.1997V13.1997C12.3656 13.3656 12.6344 13.3656 12.8003 13.1997V13.1997L15.5 10.5","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
